import { compose, withProps } from 'recompose'
import { isNil } from 'ramda'

import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const formatZip = useLongZip => value => {
  if (!value) return ''
  if (useLongZip) {
    // Remove any non-digits and existing hyphens
    const digits = value.replace(/\D/g, '')

    // If more than 5 digits, insert hyphen after first 5
    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`
    }

    // Return just the digits if 5 or fewer
    return digits
  } else {
    // If the user modifies digits within sections, it will pass the validation,
    // because we don't want to re-render all the time, which cause cursor jumping.

    if (/^[0-9]{5}$/.test(value)) return value

    // Formatting
    const clean = (value.match(/[0-9]/g) || []).join('')
    return clean.substr(0, 5)
  }
}

const parseZip = value => {
  if (!value) return ''
  const newValue = value.replace(/-/g, '')
  return newValue
}

const enhance = compose(
  withProps(props => ({
    // using normalize instead o format because the form validation
    // is checking against what's in redux, but format only affects
    // what the user sees in the field, not what is getting saved.
    format: formatZip(props.useLongZip),
    // parses is used to remove hyphens for BE calls.
    parse: parseZip,
  })),
  toReduxFormField('InputZip'),
)

export default enhance(InputText)
